var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreasPrograma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6663 58.3333V58.4167M133.333 125V125.083M90.233 81.9C94.8958 77.2386 98.0715 71.2992 99.3585 64.8329C100.645 58.3666 99.9859 51.6639 97.4633 45.5724C94.9407 39.4809 90.6683 34.2744 85.1864 30.6112C79.7046 26.9481 73.2595 24.9929 66.6664 24.9929C60.0732 24.9929 53.6282 26.9481 48.1463 30.6112C42.6644 34.2744 38.392 39.4809 35.8694 45.5724C33.3468 51.6639 32.6873 58.3666 33.9743 64.8329C35.2612 71.2992 38.4369 77.2386 43.0997 81.9L66.6664 105.475L90.233 81.9ZM156.9 148.567C161.562 143.905 164.738 137.966 166.025 131.5C167.312 125.033 166.653 118.331 164.13 112.239C161.607 106.148 157.335 100.941 151.853 97.2779C146.371 93.6148 139.926 91.6595 133.333 91.6595C126.74 91.6595 120.295 93.6148 114.813 97.2779C109.331 100.941 105.059 106.148 102.536 112.239C100.013 118.331 99.3539 125.033 100.641 131.5C101.928 137.966 105.104 143.905 109.766 148.567L133.333 172.142L156.9 148.567Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreasPrograma);
export default __webpack_public_path__ + "static/media/AreasPrograma.ef5369e041eabac8f5a80c442bab734f.svg";
export { ForwardRef as ReactComponent };